import { render, staticRenderFns } from "./OrderFormOrderItemsToolbar.vue?vue&type=template&id=5a6d46d6"
import script from "./OrderFormOrderItemsToolbar.vue?vue&type=script&lang=js"
export * from "./OrderFormOrderItemsToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports